<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      show-save-button
      unit="账号"
      edit-title
      id-key="AccountId"
      :data="data"
      @create-opened="onCreateOpened"
      @opened="$refs.typeSelect.init()"
      @closed="$refs.typeSelect.clear()"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="账号类别" prop="ClassId">
          <type-select ref="typeSelect" v-model="data.ClassId" />
        </el-form-item>
        <el-form-item label="账号编码" prop="AccountNo">
          <span v-if="Mode==0" class="detail-span">{{data.AccountNo}}</span>
          <el-input v-else v-model="data.AccountNo" placeholder="请输入账号编码"></el-input>
        </el-form-item>
        <el-form-item label="账号名称" prop="AccountName">
          <el-input v-model="data.AccountName" placeholder="请输入账号名称" />
        </el-form-item>
        <el-form-item label="账号类型" prop="AccountTypeId">
          <account-type v-model="data.AccountTypeId" @select="setType" />
        </el-form-item>
        <el-form-item label="开户银行" prop="BankName" :rules="data.HaveBank?bank.BankName:null">
          <el-input v-model="data.BankName" placeholder="请输入开户银行" />
        </el-form-item>
        <el-form-item label="银行账号" prop="BankNo" :rules="data.HaveBank?bank.BankNo:null">
          <el-input v-model="data.BankNo" placeholder="请输入银行账号" />
        </el-form-item>
        <el-form-item label="当前余额" prop="Balance">
          <el-input v-model="data.Balance" v-num placeholder="请输入当前余额" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import typeSelect from "./type/select";
import accountType from "@/components/basedata/finance/accountType/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
    accountType,
  },
  data() {
    return {
      data: {
        AccountId: 0,
        AccountNo: "",
        AccountName: "",
        AccountTypeId: null,
        HaveBank: false,
        ClassId: 0,
        ClassName: "",
        BankName: "", //开户银行
        BankNo: "", //开户银行账号
        Balance: 0, //余额
        Sn: 0,
        Status: 1,
      },
      Mode: 0,
      api: require("@/api/ba/account").default,
      code_api: require("@/api/sy/serialCode").default,
      rules: {
        AccountNo: [{ required: true, message: "账号编码不能为空" }],
        AccountName: [{ required: true, message: "账号名称不能为空" }],
        AccountTypeId: [{ required: true, message: "请选择账号类型" }],
        Balance: [{ required: true, message: "当前余额不能为空" }],
        ClassId: [{ required: true, message: "请选择账号类别" }],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
      bank: {
        BankName: [{ required: true, message: "开户银行不能为空" }],
        BankNo: [{ required: true, message: "银行账号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });

      this.code_api.previewNo('账号').then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.AccountNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取账号编号失败");
        }
      });
    },
    setType(data) {
      if (data) this.data.HaveBank = data.HaveBank;
      else this.data.HaveBank = false;
      this.$refs.dialog.clearValidate();
    },
  },
};
</script>